module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAYAAABNChwpAAABXUlEQVRIieXWv0ocURTH8c9qNoIuItqn0cJGECEQUGwU9QH2AVJYWhjIAwjpBAs7SWOC3T6CjeTPLioIimlSWWgrCCIxCFEGJrKBmXGWcecW+cEdhnt+c86XmXvvnEqj0VBAL7GBt+jHHt7hNG/KniLVsYkV1OJcc/iKV2UADGM5YX4I78sAGMeLlNhsGQDDGbHRMgDGMmK1MgCWCjxbGGACCxnx624CRHv/IyoZnqtuAUTFd/DmCd+PvAnTtlGSprCF1zm8VawmzN/G4wzf8CcCGMQ0+tqMl/iOgTjRImY6gJ2PR5b2o3UUAXzBZIJxDZ/xoYPCnSj6jOs9KcV1cpoVUD1rEfaWADBS9G9YVD9DAxyEBjj8rwF+4yQkwDHuQgIcRJeQAK3QAM2QAOe4CAnQ+nsTCqCZF6DaJYB/3sB9iulX3JA8t3Zx1A7wKaFC1DZtP3Plm7iZrT/O4AHCiDHRQc/xqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hand.png
// module id = Tnox
// module chunks = 0